import * as Types from '../constants/Types';

export const getListAgents = (filters) => ({ type: Types.AGENT_LIST_ACTION, filters });
export const getAllAgents = (filters) => ({ type: Types.AGENT_ALL_LIST_ACTION, filters });
export const setListAgents = (agents) => ({ type: Types.AGENT_LIST_SUCCESS, agents});

export const getAgentDetail = (id) => ({ type: Types.AGENT_DETAIL_ACTION, id });
export const setAgentDetail = (agent) => ({ type: Types.AGENT_DETAIL_SUCCESS, agent });
export const updateAgentDetail = (agent) => ({ type: Types.AGENT_DETAIL_UPDATE_ACTION, agent });
export const createAgentDetail = (agent) => ({ type: Types.AGENT_DETAIL_CREATE_ACTION, agent });
export const deleteAgentDetail = (agent, filters) => ({ type: Types.AGENT_DETAIL_DELETE_ACTION, agent, filters });

export const getAgentListReports = (params) => ({ type: Types.AGENT_LIST_REPORTS_ACTION, params });
export const setAgentListReports = (reports, params) => ({ type: Types.AGENT_LIST_REPORTS_SUCCESS, reports, params });


